import Swiper from 'swiper'

function initMitopureTransformation() {
  const sections = document.querySelectorAll('[data-mitopure-transformation]')
  if (!sections || sections.length === 0) return

  sections.forEach((sectionEl) => {
    const tiles = Array.from(sectionEl.querySelectorAll('[data-mitopure-tile]'))
    const triggers = Array.from(sectionEl.querySelectorAll('[data-mitopure-trigger]'))
    const viewport = sectionEl.querySelector('[data-mitopure-swiper]')
    const prevButton = sectionEl.querySelector('[data-mitopure-prev]')
    const nextButton = sectionEl.querySelector('[data-mitopure-next]')
    const mobileTriggers = Array.from(
      sectionEl.querySelectorAll('[data-mitopure-mobile-trigger]')
    )
    const mobileQuery = window.matchMedia('(max-width: 749px)')

    if (tiles.length === 0 || triggers.length === 0 || !viewport) return

    let activeIndex = tiles.findIndex((tile) => tile.classList.contains('is-active'))
    let swiper = null

    if (activeIndex < 0) activeIndex = 0

    const getActiveMediaHeight = () => {
      const activeTile = tiles[activeIndex]
      if (!activeTile) return 0
      const mediaEl = activeTile.querySelector('.mitopure-transformation__media')
      return mediaEl ? mediaEl.offsetHeight : 0
    }

    const getActiveContentHeight = () => {
      const activeTile = tiles[activeIndex]
      if (!activeTile) return 0

      const detailsEl = activeTile.querySelector('.mitopure-transformation__details')
      if (!detailsEl) return 0

      const detailsHeight = detailsEl.scrollHeight || detailsEl.offsetHeight || 0
      const detailsTop = detailsEl.offsetTop || 0

      return Math.ceil(detailsTop + detailsHeight)
    }

    const lockHeightsByActiveTile = () => {
      if (mobileQuery.matches) {
        sectionEl.style.removeProperty('--mitopure-active-media-height')
        sectionEl.style.removeProperty('--mitopure-content-min-height-runtime')
        return
      }

      sectionEl.style.removeProperty('--mitopure-content-min-height-runtime')

      const initialIndex = activeIndex
      const initialTile = tiles[initialIndex]
      const initialContentEl = initialTile
        ? initialTile.querySelector('.mitopure-transformation__content')
        : null
      const defaultContentMinHeight = initialContentEl
        ? parseFloat(window.getComputedStyle(initialContentEl).minHeight) || 0
        : 0
      let maxMediaHeight = 0
      let maxContentHeight = defaultContentMinHeight

      sectionEl.classList.add('is-measuring-media-height')

      tiles.forEach((_, index) => {
        setActive(index, false, false)
        maxMediaHeight = Math.max(maxMediaHeight, getActiveMediaHeight())
        maxContentHeight = Math.max(maxContentHeight, getActiveContentHeight())
      })

      setActive(initialIndex, false)
      sectionEl.classList.remove('is-measuring-media-height')

      if (maxMediaHeight > 0) {
        sectionEl.style.setProperty('--mitopure-active-media-height', `${maxMediaHeight}px`)
      }

      if (maxContentHeight > 0) {
        sectionEl.style.setProperty('--mitopure-content-min-height-runtime', `${maxContentHeight}px`)
      }
    }

    const syncTileVideos = () => {
      tiles.forEach((tile, tileIndex) => {
        const tileVideo = tile.querySelector('.mitopure-transformation__video')
        if (!tileVideo) return

        if (tileIndex === activeIndex) {
          tileVideo.muted = true
          const playPromise = tileVideo.play()
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {})
          }
          return
        }

        tileVideo.pause()
        try {
          tileVideo.currentTime = 0
        } catch (error) {
          // Ignore reset errors until metadata is available.
        }
      })
    }

    const setActive = (index, syncSwiper = true, syncVideos = true) => {
      if (index < 0 || index >= tiles.length) return
      activeIndex = index

      tiles.forEach((tile, tileIndex) => {
        const isActive = tileIndex === activeIndex
        tile.classList.toggle('is-active', isActive)

        const trigger = triggers[tileIndex]
        if (trigger) {
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false')
        }

        const mobileTrigger = mobileTriggers[tileIndex]
        if (mobileTrigger) {
          mobileTrigger.classList.toggle('is-active', isActive)
        }
      })

      if (syncSwiper && swiper) {
        swiper.slideTo(activeIndex)
      }

      if (syncVideos) {
        syncTileVideos()
      }
    }

    const mountMobileSwiper = () => {
      if (swiper) return

      if (viewport.swiper) {
        viewport.swiper.destroy(true, true)
      }

      swiper = new Swiper(viewport, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        centeredSlides: false,
        watchOverflow: true,
        resistanceRatio: 0.85,
        allowTouchMove: false,
        initialSlide: activeIndex,
      })

      swiper.on('resize', () => {
        setActive(activeIndex)
        lockHeightsByActiveTile()
      })
    }

    const unmountMobileSwiper = () => {
      if (!swiper) return
      swiper.destroy(true, true)
      swiper = null
    }

    const syncByViewport = () => {
      if (mobileQuery.matches) {
        mountMobileSwiper()
      } else {
        unmountMobileSwiper()
      }
      setActive(activeIndex)
      lockHeightsByActiveTile()
    }

    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        setActive(index)
      })
    })

    mobileTriggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        setActive(index)
      })
    })

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        const nextIndex = (activeIndex - 1 + tiles.length) % tiles.length
        setActive(nextIndex)
      })
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        const nextIndex = (activeIndex + 1) % tiles.length
        setActive(nextIndex)
      })
    }

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncByViewport)
    } else if (typeof mobileQuery.addListener === 'function') {
      mobileQuery.addListener(syncByViewport)
    }

    let resizeRaf = null
    const onResize = () => {
      if (resizeRaf) return
      resizeRaf = window.requestAnimationFrame(() => {
        resizeRaf = null
        lockHeightsByActiveTile()
      })
    }

    window.addEventListener('resize', onResize)

    syncByViewport()
  })
}

export default initMitopureTransformation